RivalIQ.apps.SocialPosts.module('curations', function (curations, App, Backbone, Marionette, $, _, s) {

    'use strict';


    const ConfirmExitModal = RivalIQ.views.ItemView.mixin({
        className: 'post-tag-manager-exit-confirm',
        template: '#postTagsManagerConfirmExitModalTemplate',

        ui: {
            confirmExitBtn: '.x-confirm-exit',
            cancelBtn: '.x-cancel'
        },

        events: {
            'click @ui.confirmExitBtn': 'onConfirmExit',
            'click @ui.cancelBtn': 'onCancelExit'
        },

        onConfirmExit: function () {
            const me = this;

            me.getOption('confirmNavigation')();
            RivalIQ.execute('hide:modal');
        },

        onCancelExit: function () {
            RivalIQ.execute('hide:modal');
        }
    });

    curations.PostTagsManager = curations.SocialPosts.extend({
        title: 'Post Tag Manager',

        exportFormats: [],

        page: {},

        widgetsView: curations.Layout.extend({
            template: '#dashboardPostTagsLayoutTemplate',
            className: 'flex-toolbar-layout post-tags-manager-curation in-post-tags-edit-mode',

            getConfig: _.constant([
                {
                    name: 'post-tags-manager',
                    sizes: {
                        md: 12
                    },
                    page: 0
                }
            ]),

            showActions: function () {
                const me = this;

                me.actions.empty();
            },

            showLeftToolbarActions: function () {
                const me = this;

                const urlParams = new URLSearchParams(window.location.search);
                const fromLink = urlParams.get('from');

                if (fromLink) {
                    const pathStart = fromLink.slice(1);
                    const curationId = _.findKey(RivalIQ.apps.Dashboard.router.router.curationMapping, pathRe => {
                        return pathStart.match(RivalIQ.apps.Dashboard.router.router._routeToRegExp(pathRe));
                    });

                    if (curationId) {
                        const route = RivalIQ.apps.Dashboard.router.router._routeToRegExp(RivalIQ.apps.Dashboard.router.router.curationMapping[curationId]);
                        const params = route.exec(pathStart).slice(1);
                        const mapping = RivalIQ.apps.Dashboard.router.router.routeMapping[route];

                        const pathParams = {};

                        if (mapping) {
                            _.each(params.slice(0, -1), function (param, i) {
                                pathParams[mapping[i]] = param;
                            });
                        }
                    }

                    const linkName = '<span class="fa fa-chevron-left" />';
                    me.leftActions.show(new RivalIQ.views.Link({
                        className: 'btn btn-default btn-back-link',
                        linkName: linkName,
                        attributes: {
                            href: '#'
                        },
                        action: function () {
                            RivalIQ.execute('history:navigate', fromLink, {
                                trigger: true
                            });
                        }
                    }), {
                        preventDestroy: true
                    });
                }

                me.leftActions.show(new App.views.Search({
                    dashboardModel: me.dashboardModel,
                    companyData: me.dashboardModel.companyData
                }), {
                    preventDestroy: true
                });
            },

            serializeData: function () {
                const me = this;

                const data = curations.Layout.prototype.serializeData.call(me);

                const curation = me.dashboardModel.getCuration();
                data.analysisLink = curation.router.resolveCurationRoute(RivalIQ.enums.curation.POSTTAGS, {
                    instanceId: null,
                    channel: me.getProp('channel')
                });

                return data;
            },

            _handleError: function () {
                const me = this;
                if (me.error) {

                    me.requestRenderedFrame(function () {

                        me.historyLimit.$el.hide();

                        const errorName = me.error.errorName || me.error.name;
                        const hideTryAgain = _.includes(['SearchQueryTooLongError', 'InvalidDateError'], errorName);
                        me.showTryAgainMessage(me.getMessageForError(me.error), hideTryAgain);
                        me.ui.widgets.hide();
                        me.loadingView.hideForView(me);
                    });
                }
            }
        }),

        getCurationId: function () {
            const me = this;
            return s.dasherize([me.id.toLowerCase(), me.getProp('channel')].join('-'));
        },

        titleView: function () {
            const me = this;
            return me.getTitle();
        },

        initialize: function () {
            const me = this;

            // Override the navigation handler so we can tell people not to leave when they have pending work.
            me._navigateOriginal = Backbone.history.navigate;
            Backbone.history.navigate = function (path, navigateOptions) {
                if ($('.post-container input[type=checkbox]:checked').length) {
                    const modal = new ConfirmExitModal({
                        confirmNavigation: () => {
                            Backbone.history.navigate = me._navigateOriginal;
                            Backbone.history.navigate(path, navigateOptions);
                        }
                    });

                    RivalIQ.execute('show:modal', {
                        size: 'small',
                        contentView: modal
                    });
                } else {
                    Backbone.history.navigate = me._navigateOriginal;
                    Backbone.history.navigate(path, navigateOptions);
                }
            };

            curations.SocialPosts.prototype.initialize.call(me, arguments);
        },

        teardown: function () {
            const me = this;

            if (me._navigateOriginal) {
                Backbone.history.navigate = me._navigateOriginal;
            }
        },

        // This curation behaves like the posts table in details view
        validCurationOptions: App.utils.validWidgetOptions
    });

}, window.s);
